import {
    StyleSheet, SectionList, Pressable,
    SafeAreaView, Image, ActivityIndicator, useWindowDimensions
} from 'react-native'
import { useTheme } from '@react-navigation/native';
import CustomInput from '../CustomInput';
import CustomLabel from '../CustomLabel/CustomLabel';
import { createCommonStyles } from '../../styles/commonStyles';
import { useTranslation } from 'react-i18next';
import { DEFAULTPROFILE } from '../../img/DefaultProfile';
import CustomActivityIndicator from '../CustomActivityIndicator/CustomActivityIndicator';

const EmployeeList = (props) => {
    const { employees, isLoading, selectedEmployee, setSelectedEmployee, searchQuery, setSearchQuery } = props
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions();
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const styles = makeStyles(colors);

    return (
        <SafeAreaView style={styles.employeeList}>
            <SafeAreaView style={[common.cardstyle, styles.search]}>
                {/* search */}
                <CustomInput
                    value={searchQuery || ""}
                    setValue={setSearchQuery}
                    type='SELECT_EMPLOYEE'
                    placeholder={`${t('common:search')}...`}
                />
                <SafeAreaView style={common.divider} />
                <CustomLabel
                    value={searchQuery ? `${t('common:searchResults')}${searchQuery}` : t('common:searchResults')}
                    type={'SELECT_EMPLOYEE_SELECTED_COMPANY'}
                />
                <SafeAreaView style={common.divider} />
            </SafeAreaView>
            {/* card with list of employees */}
            <SafeAreaView style={[common.cardstyle, styles.employeeSearchList]}>
                {isLoading
                    ?
                    <CustomActivityIndicator />
                    :
                    employees?.length > 0
                        ?
                        <SectionList
                            sections={employees}
                            keyExtractor={(item, index) => item.employeeId}
                            initialNumToRender={30}
                            contentContainerStyle={{
                                paddingHorizontal: 10,
                                maxHeight: height * 0.5,
                            }}
                            renderItem={({ item }) => (
                                <SafeAreaView>
                                    <Pressable
                                        onPress={() => setSelectedEmployee(item)}
                                        style={() => [item.employeeId === selectedEmployee?.employeeId ? styles.selectedItem : null]}
                                    >
                                        <SafeAreaView style={styles.employeeContainer}>
                                            <Image
                                                style={styles.employeePhotograph}
                                                source={{ uri: `data:image/png;base64,${item.photograph || DEFAULTPROFILE}` }}
                                            />
                                            <SafeAreaView style={[common.listTitle, { marginHorizontal: 10, }]}>
                                                <CustomLabel
                                                    value={item.name}
                                                    type='AVAILABLEUSED_SECONDARY'
                                                    align='flex-start'
                                                />
                                                <CustomLabel
                                                    value={item.seniority}
                                                    type='AVAILABLEUSED_MUTED'
                                                    align='flex-start'
                                                />
                                            </SafeAreaView>
                                        </SafeAreaView>
                                        <SafeAreaView style={common.divider} />
                                    </Pressable>
                                </SafeAreaView>
                            )}
                            renderSectionHeader={({ section: { title } }) => (
                                <CustomLabel
                                    value={title}
                                    type='MAJOR' />
                            )}
                        />
                        :
                        searchQuery
                            ?
                            <SafeAreaView
                                style={styles.cardEmployees}>
                                <CustomLabel
                                    value={t("common:noResultsFound")}
                                    type="ASSM"
                                />
                            </SafeAreaView>
                            :
                            null
                }
            </SafeAreaView>
        </SafeAreaView>
    )

}

const makeStyles = (colors) => StyleSheet.create({
    employeeList: {
        flex: 1,
        margin: 10,
    },
    cardEmployees: {
        flex: 1,
        marginTop: "1%",
        marginLeft: "2%",
        marginRight: "2%",
    },
    search: {
        backgroundColor: colors.background,
        marginHorizontal: 10,
    },
    employeeSearchList: {
        flex: 1,
        margin: 10,
    },

    selectedItem: {
        borderWidth: 4,
        borderColor: colors.buttons_primary,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
    },
    employeeContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        margin: 5,
    },

    employeePhotograph: {
        width: 30,
        height: 30,
        marginLeft: 10,
        borderRadius: 100,
        borderWidth: 1,
        verticalAlign: 'middle',
    },
});

export default EmployeeList;